import { render } from "./ReceiveOrderModal.vue?vue&type=template&id=234e33bc&scoped=true"
import script from "./ReceiveOrderModal.vue?vue&type=script&lang=js"
export * from "./ReceiveOrderModal.vue?vue&type=script&lang=js"

import "./ReceiveOrderModal.vue?vue&type=style&index=0&id=234e33bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234e33bc"]])

export default __exports__